import "./src/styles/global.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import * as React from "react";
import AppContextProvider from "./src/context/app";
import AppRoot from "./src/components/AppRoot";

export const wrapRootElement = ({ element }) => {
  return <AppContextProvider>{element}</AppContextProvider>;
};

export const wrapPageElement = ({ element }) => {
  return <AppRoot>{element}</AppRoot>;
};
